import {
    Box,
    Grid,
    Button,
    Select,
    IconButton,
    Backdrop,
    ButtonGroup,
    CircularProgress,
    TextField,
    MenuItem,
    GridRowParams,
  } from "@mui/material";
  import {
    GetUserCountries,
    ExportSkuReplacementData,
    UpdateUOMSKU,
    setState,
    GetUOMs,
  } from "../centralAdminSlice";
import CollapseSection from "../../../components/ui/CollapseSection";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import Alert from "../../../components/ui/Alert";
import axios from "axios";
import { centralAdminUrls } from "../centralAdminUtils";
import SharedComponent from "../SharedComponent";
import _ from "lodash";
import SingleSelectUOM from "./SingleSelectUOM";
import muiConfig from '../../../assets/MuiConfig.json'

export default function UOM_Component(){
    const dispatch = useDispatch();
    const centralAdmin = useSelector((state) => state.centralAdmin);
    const {
      countries,
      selectedCountry,
      selectedCountryID,
      UOMs,
      SelectedUOM,
    } = centralAdmin;   

    const loginState = useSelector((store) => store.login);
    const { globalSelectedCountryName,globalSelectedCountryID,} = loginState         

    const [isLoading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const[selectedRows,setSelectedRows]=useState([]);

    const [validate, setValidate] = useState({
        countryValidated: false,
      });    

      const [alert, setAlert] = useState({
        alertSeverity: "",
        alertDisplay: false,
        alertMessage: "",
      });

    const[rows,setRows]=useState([]);
   
    
    const UOMEditComponent=({id,uoMddl,clientProductCode,onChange,uomType,isAddedSKU})=>{
        debugger;
        const row=rows.find((row)=>row.id===id);
        return(
            <Select 
            sx={{
              width: 200,
              height: "38px !important",
              mt: "-10px !important",
            }}
            value={uomType}
            onChange={(e)=>onChange(e.target.value)}
            fullwidth 
            disabled={!row||!row.uoMddl||row.uoMddl.length===0||isAddedSKU===1}
            >
            {
                row?.uoMddl.map((uom)=>(
                    <MenuItem key={uom.uoMSAPCode} value={uom.uoMSAPCode}>{uom.uoMSAPCode}</MenuItem>
                ))}

            </Select>

        );
    };




    const columns=[
        {field:'clientProductCode',headerName:'SKU Number',flex: 1.8},
        {field:'productName',headerName:'SKU Description',flex: 3},
        {field:'uoMddl',headerName:'UOM',flex: 1.5,
        renderCell:(params)=><UOMEditComponent  
        id={params.id}
        uomType={params.row.uomType}
        uoMddl={params.row.uoMddl}
        clientProductCode={params.row.clientProductCode}
        isAddedSKU={params.row.isAddedSKU}
        onChange={(value)=>handleUOMGridChange(params.id,value)}
        />,
    },
    {field:'countryName',headerName:'Country Name',flex: 1.5},
    ];    

      useEffect(() => {
        if (countries.length <= 0) {
          dispatch(GetUserCountries({ method: "Get" }));
        }
      }, [searchText]);  
      
      useEffect(() => {
        debugger;
        if (UOMs.length <= 0) {
          dispatch(GetUOMs({ method: "Get" }));
        }
      }, [searchText]);   
      
      useEffect(() => {
        if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
          dispatch(setState("selectedCountry", globalSelectedCountryName));
          dispatch(setState("selectedCountryID", globalSelectedCountryID));
          setValidate({
            ...validate,
            countryValidated: true,
          });
    
        }
        else{
            dispatch(setState("selectedCountry", ""));
            dispatch(setState("selectedCountryID", null));
        }
      }, []);        

    
    
    const handleCountryChange = (e) => {
        const name = e.target.value;
    
        const countryID = countries.find(
          (country) => country.countryName === name
        ).countryID;
    
        if (name) {
          setValidate({
            ...validate,
            countryValidated: true,
          });
        }
    
        dispatch(setState("selectedCountry", name));
        dispatch(setState("selectedCountryID", countryID));
      };   

      // const handleUOMChange = (e) => {
      //   const name = e.target.value;
      //   dispatch(setState("SelectedUOM", name));
      // };      

      const handleSearchText = (e) => {
        const value = e.target.value;
        setSearchText(value);
      };   
      
      const handleUOMGridChange=(id,value)=>{
        debugger;
        console.log('handleUOMGridChange',value);
        setRows(prevRows=>
            prevRows.map(
                (row)=>row.id===id?{...row,uomType:value}:row
            ))
      }

      const displayAlert = (showAlert, alertMessage) => {
        setAlert({
          alertSeverity: "warning",
          alertDisplay: `${showAlert}`,
          alertMessage: `${alertMessage}`,
        });
      };      
      
      const handleDisplay = () => {
debugger;
        let obj = {
          countryID: selectedCountryID,
          uom:SelectedUOM,
          productName: searchText,
        };
    
       // if (!validate.countryValidated)
       if(selectedCountryID===0)
          displayAlert(true, "Please select a Country");
        else {
            GetSKUforUOMSearch(obj);
        }
      };  
    



      const GetSKUforUOMSearch =(obj)=>{
        debugger
        const baseUrl =
        centralAdminUrls.getSKUforUOM +
        "CountryID=" +
        obj.countryID +
        "&ProductName=" +
        obj.productName +
        "&UoMType="
        +obj.uom;

        const autherization = localStorage.getItem("data");
        const data = JSON.parse(autherization);
        const token = data.token;
        
        setIsLoading(true);
        axios
        .get(baseUrl, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
            debugger;
          const data = response.data;
          setRows(data);
          setSelectedRows([]);
          setIsLoading(false);
          if (data.length <= 0) {
            dispatch(setState("isFailed_Info", "No records to display."));
            dispatch(setState("isFailed", true));
            return;
          }

        });
      };

      const handleSaveChanges = () => {
    const selectedData = rows.filter((row) => selectedRows.includes(row.id))
    .map((row) => ({
        ProductID:row.productID,
        UoMSAPCode:row.uomType,
    }));
    dispatch(UpdateUOMSKU(selectedData)).then(() => handleDisplay());
      }      
      
      

return (
    <CollapseSection title="List of SKUs">
        <br />
        {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}        
        <Grid
        container
        columns={5}
        justifyContent="flex-start"
        alignItems="center"
        spacing={3}
        pb={1}
      >
        <Grid item xs={6} sm={3} md={4} lg={1}>
          <TextField
            variant="outlined"
            label="Country"
            select={countries.length > 0 ? true : false}
            value={countries.length > 0 ? selectedCountry : ""}
            onChange={handleCountryChange}
            fullWidth
            size="small"
          >
            {countries.length > 0
              ? countries.map((country, index) => {
                  return (
                    <MenuItem
                      key={country.countryID}
                      value={country.countryName}
                    >
                      {country.countryName}
                    </MenuItem>
                  );
                })
              : null}
          </TextField>
        </Grid>

        <Grid item xs={6} sm={3} md={4} lg={1}>     

        <SingleSelectUOM getSKUbyCountry={UOMs} />        

          {/* <TextField
            variant="outlined"
            label="UOM"
            select={UOMs.length > 0 ? true : false}
            value={UOMs.length > 0 ? SelectedUOM.countryName : ""}
            onChange={handleUOMChange}
            fullWidth
            size="small"
          >
            {UOMs.length > 0
              ? UOMs.map((uom, index) => {
                  return (
                    <MenuItem
                      key={uom.uom_sap_code}
                      value={uom.uom_sap_code}
                    >
                      {uom.uom_sap_code}
                    </MenuItem>
                  );
                })
              : null}
          </TextField> */}
        </Grid>  

          <Grid item xs={6} sm={3} md={4} lg={1}>
            <TextField
              variant="outlined"
              label="Search"
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>          

          <Grid item xs={12} sm={3} md={1} lg={0.5}>
            <Box justifyContent="center" display="flex">
              <Button variant="contained" onClick={handleDisplay} size="large"
               sx={{
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "darkred.main",
                  color: "white.main",
                },
              }}>
                Search
              </Button>
            </Box>
          </Grid>

        </Grid>   

        <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />

      <Box
        mt={2}
        sx={{
          width: "100%",
          display: rows.length > 0 ? "block" : "none",
        }}
      >
        <DataGridPro  
          style={{ maxHeight: "calc(100vh - 130px)" }}
          sx={{
            m: 2,
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
            },
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
              height: "100px",
            },
            "& .MuiDataGrid-columnHeaders": {
              maxHeight: "268px !important",
            },
          }}
          disableColumnMenu        
        columns={columns} 
        rows={rows || []}
        initialState={{
          pagination: { paginationModel: { pageSize:20, page:0 }}
        }}
        pagination
        pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={(ids)=>setSelectedRows(ids)}
        rowSelectionModel={selectedRows}
          //isRowSelectable={(params) => params.row.isCheckboxSelected === "Yes"}

        />
        </Box>      
        <Box my={2} />   
        <Grid
        container
        columns={12}
        justifyContent="flex-end"
        alignItems="right"
        my={2}
      >
        <ButtonGroup variant="text" aria-label="Basic button group">
          {selectedRows.length>0 && (
            <Button 
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 1,
              mr: 2,
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}            
            onClick={handleSaveChanges}> Save changes</Button>
          )}
        </ButtonGroup>
      </Grid>            

    </CollapseSection>
)

}